module.exports = __webpack_public_path__ + "img/musicology.cd5a691b.png";